import { get, del, postFd } from "@utils/axios";

const api = "documents";

const employmentQuery = (employmentId) => (
  employmentId ? `&predefined_employment_id=${employmentId}` : ""
);

export const getAllDocumentsReq = (payload) => {
  return get(`${api}?page=${payload.page}&filters=${payload.filters || ""}${employmentQuery(payload.employmentId)}`);
};

export const createDocumentReq = (payload) => {
  return postFd(`${api}?filters=${payload.filters || ""}${employmentQuery(payload.employmentId)}`, payload);
};

export const updateDocumentReq = (payload) => {
  return postFd(`${api}/edit?filters=${payload.filters || ""}${employmentQuery(payload.employmentId)}`, payload);
};

export const deleteDocumentReq = (payload) => {
  return del(`${api}/${payload.id}?predefined_employment_id=${payload.employmentId}`);
};

export const getDocumentTypesReq = () => {
  return get("resources/documentTypes?page=1");
};
